export var StoreAppId = 'apps';
export function getNewAdminAcquiredApps(appDefinitions, timeStamp) {
    // Return all apps acquired by admin
    if (!timeStamp)
        return appDefinitions.filter(function (app) {
            return app.id !== StoreAppId && app.acquisitionContext === 'Tenant';
        });
    if (timeStamp < 1)
        throw new Error('Invalid timestamp: ' + timeStamp);
    if (!appDefinitions.length)
        return [];
    return appDefinitions.filter(function (app) {
        var acquisitionDate = app.acquisitionDate
            ? new Date(app.acquisitionDate).getTime()
            : 0;
        return (app.id !== StoreAppId &&
            app.acquisitionContext === 'Tenant' &&
            acquisitionDate > timeStamp);
    });
}
//# sourceMappingURL=getNewAdminAcquiredApps.js.map